import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sopi-bottom',
  templateUrl: './sopi-dockpanel-bottom.component.html',
  styleUrls: ['./sopi-dockpanel-bottom.component.scss'],
})
export class SopiDockpanelBottomComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
